import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
class ViewComment extends Component {
  constructor (props) {
    super(props)
    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.state = {
      show: false
    }
  }

  handleShow () {
    this.setState({ show: true })
  }
  handleClose () {
    this.setState({ show: false })
  }

  render () {
    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        size='md'
        className='comments-modal '
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className='modal-body spComment-modal' closeButton>
          <div className='upper-div'>
            <span className='pr-md-1'> Project Name: </span>
            <span className='font-weight-bold p-10'>{this.props.taskName}</span>

            <span className='ml'>Date: </span>
            <span className='font-weight-bold'>
              {moment(this.props.commentDate).format('ddd DD MMM')}
            </span>
          </div>
          <div className='lower-div mt-4 '>
            <span>Comment:</span>
            <div className='comment-div mt-1 spComment-box'>{this.props.empComments}</div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
export default ViewComment
